import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import Helmet from "react-helmet";

const PrerenderRedirectStatus = ({ lang }: { lang?: string }) => {
  const location = useLocation();
  const first = useRef(true);
  const [redirectLocation, setRedirectLocation] = useState("");

  useEffect(() => {
    if (first.current) {
      first.current = false;
    } else {
      const to = (lang ? "/" + lang : "") + location.pathname + location.search;
      console.debug("set prerender redirect", to);
      setRedirectLocation(window.location.origin.toString() + encodeURI(to));
    }
  }, [lang, location]);

  return redirectLocation ? (
    <Helmet>
      <meta name="prerender-status-code" content={"302"} />
      <meta name="prerender-header" content={"Location: " + redirectLocation} />
    </Helmet>
  ) : null;
};

export default PrerenderRedirectStatus;
